import { GET_ERROR_HANDLER_SUCCESS } from "../constants/errorsHandlerConstants";

const initialState = {
  errorsData: null,
};

export const errorsHandlerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ERROR_HANDLER_SUCCESS:
      return {
        ...state,
        errorsData: action.payload,
      };
    default:
      return state;
  }
};
